export default "__VITE_ASSET__yRc5Y_4C__"